import { NgxLoggerLevel } from 'ngx-logger';

export const environment = {
  production: true,
  logLevel: NgxLoggerLevel.TRACE,
  serverLogLevel: NgxLoggerLevel.OFF,
  //apiServer: 'http://192.168.26.145:8085',
  apiServer: 'http://196.203.106.44/api'
};

